import { Component, inject, input, output } from '@angular/core';
import { FormControl, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { TooltipDirective, TooltipPosition } from '../../../../core/directives/tooltip';
import { AppTranslateService } from '../../../../core/services/app.translate.service';
import { IErrorMessage } from '../../../../core/types/general';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIcon } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { NgClass } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-input',
  imports: [MatFormFieldModule, MatInputModule, TranslateModule, FormsModule, ReactiveFormsModule, NgClass, MatIcon, TooltipDirective],
  templateUrl: './input.component.html',
  styleUrl: './input.component.scss',
})
export class InputComponent {
  className = input.required<string>();
  addNumberFormatting = input<boolean>(false);
  inputControl = input.required<FormControl>();
  inputType = input.required<'text' | 'number' | 'checkbox' | 'date'>();
  label = input<string>();
  placeholder = input<string>();
  readonly = input<boolean>(false);
  errorMessages = input<IErrorMessage[]>([]);
  hintMessage = input<string | null>();
  hideRequiredMarker = input<boolean>(false);
  buttonConfig = input<null | { text: string; disabled: boolean; className: string }>(null);
  infoTooltip = input<string | null>('');
  blurEvent = output<void>();
  btnClickEmitter = output<void>();
  protected readonly Validators = Validators;
  protected readonly TooltipPosition = TooltipPosition;
  protected readonly appTranslate = inject(AppTranslateService);

  getFirstError() {
    return this.errorMessages().find((e) => this.inputControl().hasError(e.errorName) && this.inputControl().touched);
  }
}
